import {NSFunctions} from './utils/functions'
import { xCore, xCoreHelper } from './core';
import { URN as NSURN } from './utils/urn';
import jQuery_LOCAL from "jquery";
import { NSUserFunctionPermissions } from './user_function_permissions';
import { NSDataModelInfo } from './data_model_info';
import { NSServerCalls } from './utils/servercalls';
import { NSGeoJson } from './utils/geojson';
import { NSResultsInterface } from './results_interface';
import { NSPageLabels } from './page_labels';
import { NSMapInterface } from './map_interface'

import SearchIcon from 'bootstrap-icons/icons/search.svg?raw'
import CleanIcon from 'bootstrap-icons/icons/x-lg.svg?raw'

var  $ = jQuery_LOCAL;

export let NSSearchbar = {}
NSSearchbar.init = function()
{

    NSSearchbarPrivate.init();

    this.f_make_ajax_call_by_fetch =          function () { return NSSearchbarPrivate.f_make_ajax_call_by_fetch.apply( NSSearchbarPrivate, arguments ); };



  
  
  


  window.NSSearchbar_ = NSSearchbar;
  window.NSSearchbarPrivate_ = NSSearchbarPrivate;
	
}


let NSSearchbarPrivate = 
{
	private_objs: {
		s_e_div_searchbar_holder_id: "header-extra-actions",
		e_div_searchbar_holder: null,
		settings : null,    // settings from config
			
		o_dd_search : //search dropdown
		{
			/*
			if user has permission these are all the searchable collections
			
				-> to these, will be added "no filter" option
			*/
			//a____CONST____searchable_collections: ['xx_rua', 'mn_processo_urbanismo', 'mn_area_processos', 'mn_loteamento'],
			
			CONST:
			{
				
				a_searchable_collection: [],	//[NSSearchbarPrivate.objs.SearchableCollection]
				//s_urn_rua : "swrefVdataset_collectionVdatasetZlandbaseVcollectionZrua"
                //s_urn_rua: "urn__SEP__table__SEP__landbase__SEP__rua"
				//s_urn_rua: "urn__SEP__table__SEP__landbase__SEP__numeros_policia"
				s_urn_rua: "urn__SEP__table__SEP__landbase__SEP__rua",
				s_urn_porta: "urn__SEP__table__SEP__landbase__SEP__numeros_policia"
				
				
			},
			
			//to sychronize "on_keypress_enter" event, that can be fired on "autocomplete.onselect" or "input.onkeypress_enter"
			o_autocomplete_sync: {
				b_autocomplete_onselect_has_been_called: false,
			},
			
			
			
			e_span_search_concept: null, //span in dd  head button
			a_e_button_search_collection: [], //array containg searchble collections
			e_button_solr_search_no_filter: null, //no filter
			
			//-----------------------
			
			
			//-----------------------
			e_button_advanced_search: null,
			
			//-----------------------
			
			
			f_init_dd: function(f_callback)
			{
				let a_searchable_collection = this.CONST.a_searchable_collection;
				
				let quick_searches_configured = NSSearchbarPrivate.private_objs.settings.text_searches;
                
                //load DataModelInfo for all tables:
                let a_s_table_urn = [];	// tables to load DataModelInfo
				
				for( let i = 0 ; i < quick_searches_configured.length ; i++)
                {		
                    let s_table_urn_i = quick_searches_configured[i].urn;	


                    let b_has_permissions = NSUserFunctionPermissions.f_has_permission_for_function_type_READ_and_collection_urn(s_table_urn_i);

                    if(b_has_permissions)
                    {
						let s_result_id_table_urn_i = quick_searches_configured[i].result_id_table_urn;
						let s_placeholder_i = NSPageLabels.f_get_label_text_by_internal_name(quick_searches_configured[i].placeholder_label_key);

						a_searchable_collection.push(new NSSearchbarPrivate.objs.SearchableCollection(	{
							urn: s_table_urn_i, 
							input_field_placeholder : s_placeholder_i,				
							a_search_column_internal_name : quick_searches_configured[i].a_search_column_internal_name,				
							result_id_column_internal_name : quick_searches_configured[i].result_id_column_internal_name,				
							result_id_table_urn : s_result_id_table_urn_i,
							a_result_column_internal_name_to_add_to_description :	quick_searches_configured[i].a_result_column_internal_name_to_add_to_description,		
							result_description_column_separator : 					quick_searches_configured[i].result_description_column_separator,				
							b_hide_search: quick_searches_configured[i].b_hide_search
						} ));
						
						a_s_table_urn.push(s_table_urn_i);	// tables to load

						if(s_result_id_table_urn_i != null && s_result_id_table_urn_i.length > 0)
						{
							a_s_table_urn.push(s_result_id_table_urn_i);
						}
                    }
				}

				// removing duplicate urns:
				a_s_table_urn = Array.from(new Set(a_s_table_urn));
                
                NSDataModelInfo.f_load_table_list____returning_promise(
					{
						a_s_table_urn: a_s_table_urn,
						b_full_info: false
					}
				).then((a_values) => {
					//console.log("---------- searchbar - just called f_load_table_list____returning_promise");
					//console.log("---------- tables loaded: " + a_s_table_urn.toString() );
                    f_callback();
                })
                .catch(error => {
                    console.error(error.message);
                    console.log(error);
                });
			}
			
		},
		
		
		e_input_searchbar_hidden_search_param: null,
		e_input_searchbar_search_input: null,
		e_button_searchbar_execute: null,
		e_button_searchbar_clean: null,
		
		
	
		
	},
	
	init: function()
	{
        let this_ = this;
        var moduleName = "NSSearchbar";
        this.private_objs.settings = xCore.modules[moduleName].settings;
	
		var e_div_searchbar_holder = document.getElementById(this.private_objs.s_e_div_searchbar_holder_id);
		this.private_objs.e_div_searchbar_holder = e_div_searchbar_holder;
		
		//NSFunctions.elem_addClass(e_div_searchbar_holder, "div_searchbar_holder");
		
		this.private_objs.o_dd_search.f_init_dd( () => 
            {
                this_.f_init_part_2_();
            }
        );
		
		
		
		
	},
    f_init_part_2_: function()
    {
        this.f_create();
		
		
		let s_urn_rua = this.private_objs.o_dd_search.CONST.s_urn_rua;
		let s_button_html_id = this.o_dd_search_struct.f_get_dd_button_html_id_by_col_urn(s_urn_rua);
		let e_button = document.getElementById(s_button_html_id);

		let o_in = 
		{
			s_col_urn: s_urn_rua,
			e_button: e_button
		};

		this.o_search_solr_struct.f_init();
		
		/*
		o_in:
		{
			s_col_urn,
			e_button
		}
		*/
		this.o_search_solr_struct.f_change_search_concept_onclick(o_in);
		
    },
	f_create: function()
	{
		let private_objs = this.private_objs;		
		
		
        let s_button_dd_search_id = "button_dd_search";

		let s_title_button_dd_search = 			NSPageLabels.f_get_label_text_by_internal_name("text_search_combobox_tooltip");
		let s_title_button_searchbar_execute =	NSPageLabels.f_get_label_text_by_internal_name("text_search_button_execute_tooltip");
		let s_title_button_searchbar_clean = 	NSPageLabels.f_get_label_text_by_internal_name("text_search_button_clean_tooltip");
		
		let s_dd_ul_html = this.o_dd_search_struct.f_create_dd_ul_html(s_button_dd_search_id);

        let s_html =`
            <div id="searchbar" class="input-group">
				<button class="btn btn-dark dropdown-toggle" type="button" id="${s_button_dd_search_id}" data-bs-toggle="dropdown" aria-expanded="false" title="${s_title_button_dd_search}" >
					<span id="span_search_concept">Rua***</span> <span class="caret"></span>
				</button>
				${s_dd_ul_html}
				<input id="input_searchbar_search_input" type="text" class="form-control form-control-sm" name="x">
				<button id="button_searchbar_clean" class="btn btn-dark" type="button" title="${s_title_button_searchbar_clean}" >${CleanIcon}</button>
				<button id="button_searchbar_execute" class="btn btn-dark" type="button" title="${s_title_button_searchbar_execute}" >${SearchIcon}</button>
            </div>
        `;
		
		
		let e_div_searchbar_holder = private_objs.e_div_searchbar_holder;
		NSFunctions.f_dom_elem_append_dom_childs_by_html(e_div_searchbar_holder, s_html);

		
		//base map dropdown
		let o_dd_search = private_objs.o_dd_search;
		o_dd_search.e_span_search_concept = document.getElementById("span_search_concept");
		o_dd_search.e_button_solr_search_no_filter = document.getElementById("button_solr_search_no_filter");
		o_dd_search.e_button_advanced_search = document.getElementById("button_advanced_search");
		
		private_objs.e_input_searchbar_hidden_search_param = document.getElementById("input_searchbar_hidden_search_param");
		private_objs.e_input_searchbar_search_input = document.getElementById("input_searchbar_search_input");
		private_objs.e_button_searchbar_execute = document.getElementById("button_searchbar_execute");
		private_objs.e_button_searchbar_clean = document.getElementById("button_searchbar_clean");
		
		this.f_set_searchbar_visibility();
		
		this.f_set_buttons_behaviour();
		
	},
	
	f_execute_search_button_set_state: function (b_active)
	{
		var private_objs = this.private_objs;
		
		var e_button_searchbar_execute = private_objs.e_button_searchbar_execute;
		
		if( b_active)
		{
			e_button_searchbar_execute.removeAttribute("disabled");
		}
		else
		{
			e_button_searchbar_execute.setAttribute("disabled", "disabled");
		}
		
		
	},
	f_execute_search_button_get_state: function()
	{
		var private_objs = this.private_objs;
		
		var e_button_searchbar_execute = private_objs.e_button_searchbar_execute;
		var b_active = (e_button_searchbar_execute.getAttribute("disabled") == "disabled") ? false : true;
		
		return b_active;
	},
	
	f_clean_search_text: function()
	{
		this.private_objs.e_input_searchbar_search_input.value = "";
	},
	f_set_search_placeholder: function( some_text )
	{
		this.private_objs.e_input_searchbar_search_input.placeholder = some_text;
	},
	o_dd_search_struct: 
	{
		f_get_dd_button_html_id_by_col_urn: function(s_collection_urn)
		{
			var s_id = "id_searchbar_" + s_collection_urn;
			return s_id;
		},
		/*
		returns {SearchableCollection}
		*/
		f_get_SearchableCollection_by_urn: function(s_collection_urn)
		{
			
			var a_searchable_collection = NSSearchbarPrivate.private_objs.o_dd_search.CONST.a_searchable_collection;
			for(var i=0; i<a_searchable_collection.length; i++)
			{
				var o_searchable_collection = a_searchable_collection[i];
				if(o_searchable_collection.urn == s_collection_urn)
				{
					return o_searchable_collection;
				}
			}
			return null;
			
		},
		
		f_set_dd_head_button_span_content: function(s_html_content)
		{
			var private_objs_global = NSSearchbarPrivate.private_objs;
			private_objs_global.o_dd_search.e_span_search_concept.innerHTML = s_html_content;
		},
			
		
		f_create_dd_ul_html: function (s_button_dd_search_id)
		{
			let private_objs_global = NSSearchbarPrivate.private_objs;
			let a_searchable_collection = private_objs_global.o_dd_search.CONST.a_searchable_collection; //[NSSearchbarPrivate.objs.SearchableCollection]
			
            
			let s_html_li_list = "";
			
			for(let i=0; i<a_searchable_collection.length; i++)
			{
				
				/*
					{SearchableCollection}
					-> 
						{
							urn,
							a_search_column_internal_name,
							result_id_column_internal_name,
							result_id_table_urn,
							a_result_column_internal_name_to_add_to_description,
							placeholder,
							html_id
						}
				*/
				let o_searchable_collection = a_searchable_collection[i];
				let s_html_id = o_searchable_collection.html_id;
				let s_col_urn_i = o_searchable_collection.urn;
                let a_urn_info = NSURN.f_get_urn_info(s_col_urn_i);
                let s_schema_internal_name = a_urn_info[1];
                let s_table_internal_name = a_urn_info[2];

				
				let s_result_id_table_urn_i = o_searchable_collection.result_id_table_urn;

                
                let b_has_permissions = NSUserFunctionPermissions.f_has_permission_for_function_type_READ_and_collection_urn(s_col_urn_i);
				
				let b_use_specific_result_target_table = (s_result_id_table_urn_i != null && s_result_id_table_urn_i.length > 0)? true : false;

				let b_has_permissions_for_result_target_table = ( b_use_specific_result_target_table ) ?
						NSUserFunctionPermissions.f_has_permission_for_function_type_READ_and_collection_urn(s_result_id_table_urn_i) 
						: 
						b_has_permissions;
				
				if(b_has_permissions && b_has_permissions_for_result_target_table && !o_searchable_collection.b_hide_search)
				{
                    let o_target_table_info;
					if(b_use_specific_result_target_table)
					{
						let a_target_table_urn_info = NSURN.f_get_urn_info(s_result_id_table_urn_i);
						let s_target_table_schema_internal_name = a_target_table_urn_info[1];
						let s_target_table_internal_name = a_target_table_urn_info[2];
						o_target_table_info = NSDataModelInfo.f_get_table_info(s_target_table_schema_internal_name, s_target_table_internal_name);
					}
					else
					{
						o_target_table_info = NSDataModelInfo.f_get_table_info(s_schema_internal_name, s_table_internal_name);
					}

					let s_list_item_label =  o_target_table_info.external_name;
					
					let s_li = '<li><a class="dropdown-item" k_0="' + s_col_urn_i + '" id="' + s_html_id + '" >' + s_list_item_label + '</a></li>';
					
					s_html_li_list += s_li;
					
				}
				
				
			}

			let s_label_no_filter = NSPageLabels.f_get_label_text_by_internal_name("text_search_button_no_filter");
			let s_label_advanced_search = NSPageLabels.f_get_label_text_by_internal_name("text_search_button_advanced_search");
			

            let s_html = '\
                <ul class="dropdown-menu" aria-labelledby="' + s_button_dd_search_id + '">\
                    ' + s_html_li_list + '\
                    <li><a class="dropdown-item" id="button_solr_search_no_filter" >' + s_label_no_filter + '</a></li>\
                    <li><hr class="dropdown-divider"></li>\
                    <li><a class="dropdown-item" id="button_advanced_search" >' + s_label_advanced_search + '</a></li>\
                </ul>\
            ';
				  
			return s_html;
			
		},
		
		f_init_dd_searchsolr_onclick_events: function()
		{
			var private_objs_global = NSSearchbarPrivate.private_objs;
			var a_searchable_collection = private_objs_global.o_dd_search.CONST.a_searchable_collection; //[NSSearchbarPrivate.objs.SearchableCollection]


			var f_set_button_onclick = function(o_f_in)
			{
				var f_ = function()
				{
					NSSearchbarPrivate.o_search_solr_struct.f_change_search_concept_onclick(o_f_in);
				}
				o_f_in.e_button.onclick = f_;
			};
			
			for(var i=0; i<a_searchable_collection.length; i++)
			{

				/*
					{SearchableCollection}
					-> 
						{
							urn,
							a_search_column_internal_name,
							result_id_column_internal_name,
							result_id_table_urn,
							a_result_column_internal_name_to_add_to_description,
							result_description_column_separator,
							placeholder,
							html_id
						}
				*/
				var o_searchable_collection = a_searchable_collection[i];
				var s_html_id = o_searchable_collection.html_id;
				var s_col_urn_i = o_searchable_collection.urn;
				
				var e_button = document.getElementById(s_html_id);
				if(e_button != null)
				{
					
					var o_in = {
							s_col_urn: s_col_urn_i,
							placeholder : o_searchable_collection.placeholder,
							e_button: e_button
						};
					f_set_button_onclick(o_in);
				}
				
				
				/*
				var funcs = [];

				function createfunc(i) {
					return function() { console.log("My value: " + i); };
				}

				for (var i = 0; i < 3; i++) {
					funcs[i] = createfunc(i);
				}

				for (var j = 0; j < 3; j++) {
					funcs[j]();                        // and now let's run each one to see
				}
				*/
				
			}
			
			
			//no filter:
			var o_dd_search = NSSearchbarPrivate.private_objs.o_dd_search;
			var e_button_solr_search_no_filter = o_dd_search.e_button_solr_search_no_filter;
			var o_in____no_filter = {
							s_col_urn: "",
							e_button: e_button_solr_search_no_filter
						};
			f_set_button_onclick(o_in____no_filter);
			
			
		},
		
		
	},
	
	o_search_solr_struct:
	{
		private_objs:
		{
			s_selected_concept: null,	//possible values "collection urn" || null / "" ->implicates no filter
			
			o_pagination: {
				i_constant_max_count: 10
				
			},

			o_last_request_executed:
			{
				/**
					@summary
					{	search_text,
						a_search_table,
						limit,
						offset }
					@description last NSServerCalls.f_text_search input
				 */
				o_data_in: null,
				/**
				 * true if filter was used in last search
				 */
				b_use_filter: null,
				/**
				 * {NSSearchbarPrivate.objs.SearchableCollection}
				 */
				o_searchable_collection: null,
				
				/**
				 * true if search is for table rua, but using table porta
				 */
				b_search_rua_using_porta: null
			}
			
		},
		f_init: function()
		{
			this.f_init_text_box_beahviour();
		},
		/*
		o_in:
		{
			s_col_urn,
			e_button
		}
		*/
		f_change_search_concept_onclick: function(o_in)
		{
			let private_objs = this.private_objs;
			
			let s_col_urn = o_in.s_col_urn;
			let e_button = o_in.e_button;
			let b_use_filter = (s_col_urn!=null && s_col_urn != "")? true : false;
            /*
			permissions already tested             
            let b_has_permissions = NSUserFunctionPermissions.f_has_permission_for_function_type_READ_and_collection_urn(s_col_urn);
            if(!b_has_permissions)
            {
                return;
            }
			*/
			
			/*
			var s_collection_external_name = e_button.innerHTML;
			var s_html_content = s_collection_external_name;
			*/
			let s_list_item_external_name = e_button.innerHTML;
			let s_html_content = s_list_item_external_name;
			
			NSSearchbarPrivate.o_dd_search_struct.f_set_dd_head_button_span_content(s_html_content);
			
			NSSearchbarPrivate.f_clean_search_text();
	
			let s_placeholder_default = NSPageLabels.f_get_label_text_by_internal_name( NSSearchbarPrivate.private_objs.settings.default_placeholder_label_key ) ;
			let s_placeholder = o_in.placeholder;
			NSSearchbarPrivate.f_set_search_placeholder( s_placeholder ? s_placeholder : s_placeholder_default);
			
			private_objs.s_selected_concept = (b_use_filter)? s_col_urn : "";
			
		},
		/*
			o_in:
			{
				start,	//zero based
				rows,	//max number of returned rows
				b_get_more_results
			},
			f_callback_success -> function(o_result)
			f_callback_error -> function(o_result)
		*/
		f_execute_solr_query: function(o_in, f_callback_success, f_callback_error)
		{
			let this_ = this;
			let private_objs = this.private_objs;
			let private_objs_global = NSSearchbarPrivate.private_objs;

			let b_get_more_results = o_in.b_get_more_results;

			let o_data_in;
			let b_use_filter;
			let b_search_rua_using_porta = false;
			if(b_get_more_results) //use previos call data
			{
				o_data_in = this.private_objs.o_last_request_executed.o_data_in;
				o_data_in.offset = o_in.start;
				b_use_filter = this.private_objs.o_last_request_executed.b_use_filter;

			}
			else	//generate new o_data_in
			{
				let s_selected_concept = private_objs.s_selected_concept;
			
				b_use_filter = ( s_selected_concept!=null && s_selected_concept != "" )? true : false;
	
				let s_col_urn = s_selected_concept;
	
				let e_input_searchbar_search_input = private_objs_global.e_input_searchbar_search_input;
				let s_search_text_original = e_input_searchbar_search_input.value;

				if(s_search_text_original.length == 0)
				{
					NSSearchbarPrivate.f_execute_search_button_set_state(true);
					return;
				}
					
				/*
				returns {SearchableCollection}
				*/
				let o_searchable_collection = NSSearchbarPrivate.o_dd_search_struct.f_get_SearchableCollection_by_urn(s_col_urn);
	
				let a_search_table = [];
				if(b_use_filter)
				{

					let s_urn_rua = NSSearchbarPrivate.private_objs.o_dd_search.CONST.s_urn_rua;
					let s_urn_porta = NSSearchbarPrivate.private_objs.o_dd_search.CONST.s_urn_porta;
					if(o_searchable_collection.urn == s_urn_rua
						&& s_search_text_original.indexOf(",")>0)
					{
						b_search_rua_using_porta = true;
						o_searchable_collection = NSSearchbarPrivate.o_dd_search_struct.f_get_SearchableCollection_by_urn(s_urn_porta);
					}
					
					a_search_table.push(
						{
							table_urn: 												o_searchable_collection.urn,
							a_search_column_internal_name:							o_searchable_collection.a_search_column_internal_name,
							result_id_column_internal_name:							o_searchable_collection.result_id_column_internal_name,
							a_result_column_internal_name_to_add_to_description:	o_searchable_collection.a_result_column_internal_name_to_add_to_description,
							result_description_column_separator:					o_searchable_collection.result_description_column_separator,
						}
					);
				}
				else
				{
					let a_searchable_collection = private_objs_global.o_dd_search.CONST.a_searchable_collection; //[NSSearchbarPrivate.objs.SearchableCollection]
					a_searchable_collection.forEach( (o_sc) => {
						a_search_table.push(
							{
								table_urn: 											o_sc.urn,
								a_search_column_internal_name: 						o_sc.a_search_column_internal_name,
								result_id_column_internal_name:						o_sc.result_id_column_internal_name,
								a_result_column_internal_name_to_add_to_description:	o_sc.a_result_column_internal_name_to_add_to_description,
								result_description_column_separator:					o_sc.result_description_column_separator								
							}
						);
					})
					
				}
				
				o_data_in = {
					search_text: s_search_text_original,
					a_search_table: a_search_table,
					limit: o_in.rows,
					offset: o_in.start
				};

				this.private_objs.o_last_request_executed.o_data_in = o_data_in;
				this.private_objs.o_last_request_executed.b_use_filter = b_use_filter;
				this.private_objs.o_last_request_executed.o_searchable_collection = o_searchable_collection;
				this.private_objs.o_last_request_executed.b_search_rua_using_porta = b_search_rua_using_porta;
				
				

			}
			
			


			let f_cb_error = function(o_resp)
			{
				var s_message = "Error executing service."

				console.log(s_message);
				if(o_resp != null)
				{
					console.log(o_resp);
				}
			};

			let f_cb_success = function(o_resp)
			{
				
				if(o_resp.success)
				{
					/*console.log ("f_execute_solr_query - f_cb_success !!!!!!!!!!!!!!!!!!!!!!!!!");
					console.log("o_resp:");
					console.log(o_resp);*/

					
					this_.f_format_solr_response(o_resp, b_use_filter, f_callback_success, f_callback_error);

				}
				else
				{
					f_cb_error(o_resp);
				}
			};

			/*
				example
				o_data_in:
				{
					"search_text": "mato 42",
					"a_search_table":[
						{
							"table_urn":"urn__SEP__table__SEP__landbase__SEP__numeros_policia",
							"a_search_column_internal_name": ["rua_nome", "numero_de_policia"],
							"result_id_column_internal_name": "id_rua"
						}
	
					],
					"limit": 10,
					"offset": 0
				}
				returns promise object (handle_resolve(o_resp)) => o_resp is a json object
			*/
			let o_promise_res = NSServerCalls.f_text_search(o_data_in);
	
				o_promise_res
				.then(f_cb_success)
				.catch(f_cb_error);

			return;



		},
		
		/**
			f_callback(o_result)	// o_result -> {}

			ex:
			o_result:
			{
				suggestions: [ { value: "description text", data: {id, search_table_urn} },... ],
				start,
				numFound
			}
		*/
		f_format_solr_response: function (o_resp, b_use_filter, f_callback_success, f_callback_error)
		{
			var this_ = this;
			
			//var response = JSON.parse(o_resp);
			var response = o_resp;
				
			//array with no duplicates
			try{
				var a_rows = this.f_generateArrayWithUniqueElems(response.a_row);
			
				var o_result =  {
					suggestions: $.map(a_rows, function(dataItem) {
						
						var a_value;
						
						if( b_use_filter )
						{
							a_value =  dataItem.description;
						}
						else 
						{
							let s_search_table_urn = dataItem.search_table_urn;
							let a_urn_info = NSURN.f_get_urn_info(s_search_table_urn);
							let s_schema_internal_name = a_urn_info[1];
							let s_table_internal_name = a_urn_info[2];
							let o_table_info = NSDataModelInfo.f_get_table_info(s_schema_internal_name, s_table_internal_name);

							let s_table_external_name =  o_table_info.external_name;
							a_value =  s_table_external_name + ": " + dataItem.description;
						} 
						
						return { value:a_value, data: {id: dataItem.id, search_table_urn: dataItem.search_table_urn} };
												
					}),
					
					start: o_resp.offset,
					numFound: o_resp.total_count
				};
				
				f_callback_success(o_result);
			}
			catch(err){
				if(f_callback_error!=null)
				{
					f_callback_error(o_result);	
				}
				else
				{
					var s_message = err.message;
					throw err;
				}
			}
			
			
		},
		
		/*
			o_in = {
				i_feature_offset,
				i_feature_limit
			}
		*/
		f_get_more_results: function(o_in)
		{
			let i_feature_offset = o_in.i_feature_offset;
			let i_feature_limit = o_in.i_feature_limit;
		
			/*
			//alert("f_get_more_results!");
			//is the button active?
			if(NSSearchbarPrivate.f_execute_search_button_get_state() == false)
			{
				return;
			}
			var b_active = false;
			NSSearchbarPrivate.f_execute_search_button_set_state(b_active);
			
			
			
			var f_cb_success_ = function(o_result)
			{
				var b_active = true;
				NSSearchbarPrivate.f_execute_search_button_set_state(b_active);
			};
			
			var f_cb_error_ = function(o_result)
			{
				var b_active = true;
				NSSearchbarPrivate.f_execute_search_button_set_state(b_active);
			}
			*/
			
			let b_get_more_results = true;
			NSSearchbarPrivate.f_searchbar_execute(b_get_more_results, i_feature_offset);

			
			
		
		},
		
		
		//---------------------------------------------------------------------
		//search text box section:
		
		f_generateArrayWithUniqueElems: function(a_in)
		{
			var a_res = new Array();

			var f_elemsEquivalent = function (o1,o2){return o1.id == o2.id;};
			//var f_elemsEquivalent = function (o1,o2){return o1 == o2;};
			var f_insert_aux = function(a, elem)
				{
					for(var i=0; i<a.length; i++)
					{
						if(f_elemsEquivalent(a[i], elem))
						{
							//elem already has equivalent, not inserting
							return;
						}
					}
					a.push(elem);

				}

			for(var i=0; i<a_in.length; i++)
			{
				f_insert_aux(a_res, a_in[i]);
			}

			return a_res;


		},
		
		f_init_text_box_beahviour: function()
		{
			var this_ = this;
			
			
			/*
			var options = {
				//serviceUrl:'http://autocomplete.wunderground.com/aq?c=US&format=jsonp&cb=myresults',
				
				serviceUrl: function (e, q)
				{
					//var s_key = "teste";
					var s_key = e;
				 
					var s_q = this_.f_generate_query();
					var o_in = {
						q: s_q
					}
					/*
						o_in ->
						{
							q,	// (string), ex1: "*abril*", ex2: "q=rua:*abril*"
						}
					* /
					var sUrl = comms.f_solr_search_get_url(o_in);
				  
					return sUrl;        
				},
				 paramName : "not_used", //"indent",
				
				ajaxSettings: {
					dataType: "json",
					contentType: "application/x-www-form-urlencoded",
					crossDomain: true,
					xhrFields: {withCredentials: true}
					
					
					
				},
				minChars: 4,
				dataType : "jsonp",
				transformResult: function(response) {
					//response = JSON.parse(response);
					var oResult = response;
					
					//array with no duplicates
					var a_rows = this_.f_generateArrayWithUniqueElems(response.response.docs);
					
						return {
							suggestions: $.map(a_rows, function(dataItem) {
								return { value: dataItem.description, data: {urn: dataItem.urn} };
						})
					};
				},
				
				 zIndex : 2000, //default is 9999
				
				onSelect: function (suggestion) {
				  //alert('You selected: ' + suggestion.value + ', ' + suggestion.data);
				  //alert('You selected: ' + suggestion.value + ', ' + suggestion.data.id);
				  this_.f_selectSusggetion_(suggestion);          
				}
			};
			*/
			
			let max_results = NSSearchbarPrivate.private_objs.settings.max_results_per_search;
			
			var options = {
				
				
				lookup: function (query, done) {
				/*
				// Do Ajax call or lookup locally, when done,
				// call the callback and pass your results:
				var result = {
					suggestions: [
						{ "value": "United Arab Emirates", "data": "AE" },
						{ "value": "United Kingdom",       "data": "UK" },
						{ "value": "United States",        "data": "US" }
					]
				};

				done(result);
				*/
				
					var f_cb = function(o_resp)
					{
						done(o_resp);
					}
					var o_in = {
						rows: max_results	//max number of returned rows
					};
					/*
						o_in:
						{
							
						},
						f_callback -> function(o_result)
					*/					
					this_.f_execute_solr_query(o_in, f_cb);
				},
			
				minChars: 3,
				
				zIndex: 2000, //default is 99999
				onSelect: function (suggestion, e) {
				  //alert('You selected: ' + suggestion.value + ', ' + suggestion.data);
				  //alert('You selected: ' + suggestion.value + ', ' + suggestion.data.id);
				  
				  /*
				  console.log("-----------------------------------");
				  console.log("autocomplete - onselect");
				  */
				  NSSearchbarPrivate.private_objs.o_dd_search.o_autocomplete_sync.b_autocomplete_onselect_has_been_called = true;
				  
				  this_.f_selectSusggetion_(suggestion);
				  //alert("onselect enter");
				}
			};
			
				
			var e_input_searchbar_search_input = NSSearchbarPrivate.private_objs.e_input_searchbar_search_input;

			this.o_autocomplete = $('#'+ e_input_searchbar_search_input.getAttribute("id") ).autocomplete(options);

				
			$("#input_searchbar_search_input").on('keyup', function (e) {
				//	on enter press
				//if (e.keyCode == 13) {
				if (e.key == 'Enter') {
					//console.log("on_enter - input_parent");
					
					var b_autocomplete_onselect_has_been_called = NSSearchbarPrivate.private_objs.o_dd_search.o_autocomplete_sync.b_autocomplete_onselect_has_been_called;
					
					if(b_autocomplete_onselect_has_been_called)
					{
						//don't fire solr search
						//reset synchronization var
						NSSearchbarPrivate.private_objs.o_dd_search.o_autocomplete_sync.b_autocomplete_onselect_has_been_called = false;
					}
					else
					{
						NSSearchbarPrivate.f_e_button_searchbar_execute_onclick();
					}
					
				}
				/*
				else if(e.keyCode == 188){					
					if( NSSearchbarPrivate.o_search_solr_struct.private_objs.s_selected_concept == "swrefVdataset_collectionVdatasetZlandbaseVcollectionZrua")
						NSSearchbarPrivate.o_search_solr_struct.private_objs.s_selected_concept = "swrefVdataset_collectionVdatasetZlandbaseVcollectionZporta"
				}*/
				
				if(e.target.value.indexOf(",") > -1 ){
					if( NSSearchbarPrivate.o_search_solr_struct.private_objs.s_selected_concept == "swrefVdataset_collectionVdatasetZlandbaseVcollectionZrua")
						NSSearchbarPrivate.o_search_solr_struct.private_objs.s_selected_concept = "swrefVdataset_collectionVdatasetZlandbaseVcollectionZporta"				
				} else {
					if( NSSearchbarPrivate.o_search_solr_struct.private_objs.s_selected_concept == "swrefVdataset_collectionVdatasetZlandbaseVcollectionZporta")
						NSSearchbarPrivate.o_search_solr_struct.private_objs.s_selected_concept = "swrefVdataset_collectionVdatasetZlandbaseVcollectionZrua"					
				}
				
			});
			
			/*
			e_input_searchbar_search_input
				.addEventListener("onclick", function(event) {
				//event.preventDefault();
				if (event.keyCode == 13) {
					console.log("on_enter - input_parent");
				}
				else
				{
					console.log("key (not enter) - input_parent");
				}
			});
			*/

				
			
			
			/*
			var e_input_searchbar_search_input = NSSearchbarPrivate.private_objs.e_input_searchbar_search_input;
			console.log(e_input_searchbar_search_input.getAttribute("id"));
			$('#'+ e_input_searchbar_search_input.getAttribute("id") ).autocomplete({
				lookup: function (query, done) {
					// Do Ajax call or lookup locally, when done,
					// call the callback and pass your results:
					var result = {
						suggestions: [
							{ "value": "United Arab Emirates", "data": "AE" },
							{ "value": "United Kingdom",       "data": "UK" },
							{ "value": "United States",        "data": "US" }
						]
					};

					done(result);
				},
				onSelect: function (suggestion) {
					alert('You selected: ' + suggestion.value + ', ' + suggestion.data);
				}
			});
			*/
			
			
			
		},
		
		f_selectSusggetion_: function (suggestion)
		{
			var this_ = this; 

			//alert('You selected: ' + suggestion.value + ', ' + suggestion.data);
			//console.log('You selected: ' + suggestion.value + ', ' + suggestion.data);
			//console.log(suggestion.data);
			/*
			var suggestion_value = suggestion.value;
			var suggestion_id = suggestion.data.id;

			var s_db_name = f_getSelectedLayer_couchDBName();
			var s_key = suggestion_id;
			NSServerCalls.getObj(s_db_name, s_key, 
			function(oResult)
			{
				this_.f_selectSusggetion_ProcessServerResponse_(oResult);
			});
			*/
			
			NSMapInterface.f_if_iframe_is_visible_activate_default_map();

			let search_table_urn = suggestion.data.search_table_urn;
			let s_record_id = suggestion.data.id;
			
			let a_urn_info = NSURN.f_get_urn_info(search_table_urn);
			let s_schema = a_urn_info[1];
			let s_table_internal_name = a_urn_info[2];
			let o_geom_field_info = NSDataModelInfo.f_get_table_first_geometry_field_info(s_schema, s_table_internal_name);

			let s_suggestion_urn = NSURN.f_create_record_urn_from_table_urn(search_table_urn , s_record_id);

			/**
				@example
				o_in:
				{
					tree_node_id,
					s_urn, 
					b_clean_join_list,
					o_ll,						// (optional) - {google.maps.LatLng}
					o_geo_json					// (optional) - {GeoJson}
					s_geometry_internal_name	// internal name of the geometry field
					b_is_icon,
					a_icon_size_xy,				//[width, height]
					b_go_to						// automaticaly executes go to object function 
				}
			*/
			NSObjDetails.f_open_details_by_urn({
				s_urn: s_suggestion_urn,
				s_geometry_internal_name: (o_geom_field_info? o_geom_field_info.internal_name : null), 
				b_clean_join_list: true,
				b_go_to: true
			});


		},
		
		
		
		//---------------------------------------------------------------------
		
		/*
			returns max number of results per page
		*/
		f_get_i_constant_max_count: function()
		{
			return this.private_objs.o_pagination.i_constant_max_count;
			
			
		},

		/**
		 * 
		 * @returns {string}
		 */
		f_get_selected_concept: function()
		{
			let private_objs = this.private_objs;
			
			let s_selected_concept = private_objs.s_selected_concept;
			
			return s_selected_concept;

		},

		/**
		 * 
		 * @returns {}
		 */
		 f_get_o_last_request_executed_data: function()
		 {
			 let private_objs = this.private_objs;
			 
			 let o_last_request_executed = private_objs.o_last_request_executed;
			 
			 return o_last_request_executed;
 
		 }
		
	},
	
	f_set_searchbar_visibility: function()
	{
		
	},
	f_set_element_display_: function(e_, b_display)
	{	
		e_.style.display = (b_display)? "" : "none";
	},
	 
	f_set_buttons_behaviour: function()
	{
		var this_ = this;
		var private_objs = this.private_objs;
		
		/*
		//base map dropdown
		o_dd_search : //search dropdown
		{
			e_span_search_concept: null, //span in dd  head button
			a_e_button_search_collection: [], //array containg searchble collections
			e_button_advanced_search: null,
			
		},
		*/
		
		
		//dropdown
		
		
		
		var o_dd_search = private_objs.o_dd_search;
		//o_dd_search.e_span_search_concept = function(){this_.f_o_dd_draw_head_onclick();};
		//o_dd_search.a_e_button_search_collection = function(){this_.f_o_dd_draw_marker_onclick();};
		
		//solr search
		this.o_dd_search_struct.f_init_dd_searchsolr_onclick_events();
		
		//advanced search
		o_dd_search.e_button_advanced_search.onclick = function(){this_.f_e_button_advanced_search_onclick();};
		
		
		//private_objs.e_input_searchbar_hidden_search_param.onclick = function(){this_.f_searchbar_print_onclick();};
		//private_objs.e_input_searchbar_search_input.onclick = function(){this_.f_searchbar_export_onclick();};
		private_objs.e_button_searchbar_execute.onclick = function(){this_.f_e_button_searchbar_execute_onclick();};
		
		private_objs.e_button_searchbar_clean.onclick = function(){this_.f_clean_search_text();};
		
		
	},
	
	//o_dd_draw onclick functions
	f_e_button_advanced_search_onclick: function()
	{
		NSAdvancedSearchQueryInterface.f_show();
	},
	
	
	//other buttons onclick functions
	f_e_button_searchbar_execute_onclick: function()
	{
		var this_ = this;
		//console.log("************************************ f_execute_solr_query *************************************");
		
		//is the button active?
		if(NSSearchbarPrivate.f_execute_search_button_get_state() == false)
		{
			return;
		}
		var b_active = false;
		NSSearchbarPrivate.f_execute_search_button_set_state(b_active);
		
		this.f_searchbar_execute();
	},

	/**
	 * @param {boolean} b_get_more_results
	 * @param {int} offset
	 */
	f_searchbar_execute: function(b_get_more_results, offset)
	{
		var this_ = this;
	
		
		var i_constant_max_count = this_.o_search_solr_struct.f_get_i_constant_max_count();
		
		/*
			f_callback(o_result)	// o_result -> {}

			ex:
			o_result:
			{
				suggestions: [ { value: "description text", data: {id, search_table_urn} }, ... ],
				start,
				numFound
			}
		*/
		var f_cb = function(o_result)
		{
			var b_active = true;
			NSSearchbarPrivate.f_execute_search_button_set_state(b_active);
			
			var s_collection_urn = null;
			let a_geojson_feature = this_.f_format_data_for_results_interface(o_result.suggestions);
			
			//if in mini client mode, allways choose first result
			if( xCoreHelper.f_page_is_in_mini_client_mode() )
			{
				//if there are results, allways select first!
				if(a_geojson_feature != null && a_geojson_feature.length > 1)
				{
					let o_feature_0 = a_geojson_feature[0];

					let o_suggestion = {
						data:
						{ 
							search_table_urn: 	o_feature_0.properties_extra.search_table_urn,
							id:					o_feature_0.properties_extra.id
						}
					
					};
					this_.o_search_solr_struct.f_selectSusggetion_(o_suggestion);
				}



				return; //not calling anything else
			}
			

			/*
			let s_selected_concept = this.o_search_solr_struct.f_get_selected_concept();
			let b_use_filter = ( s_selected_concept!=null && s_selected_concept != "" )? true : false;
			let s_table_urn = s_selected_concept;
			*/


			let o_in = 
			{
				a_table: [
					{
						s_table_urn: null,
						a_geojson_feature: a_geojson_feature,
						a_column_internal_name: ["description"],
						a_column_external_name: [NSSearchbarPrivate.private_objs.settings.column_description_external_name]
					}
				],
				b_text_search_list_call: true,
				b_use_pagination: true,
				b_get_more_results_response: b_get_more_results,
				i_feature_limit: i_constant_max_count,
				i_feature_total_count: o_result.numFound,
				i_feature_offset: o_result.start,
				//f_get_more_results: function(o_get_more_results_in) { return this_.f_get_more_results(o_get_more_results_in); }
			};

			if(!b_get_more_results)
			{
				o_in.f_get_more_results = function(o_get_more_results_in) { return this_.o_search_solr_struct.f_get_more_results(o_get_more_results_in); }
			}
			/*
				o_in:
				{
					a_table, -> [
									{	s_table_urn, 			 //  (optional) used when data is just from one table in database
										a_geojson_feature, 
										a_column_internal_name, //  (optional) used when data isn't just from one table in database
										a_column_external_name  //  (optional) used when data isn't just from one table in database
									}, ...]  

					b_text_search_list_call,
					b_use_pagination,
					b_get_more_results_response		-> this call is the f_get_more_results response
					i_feature_limit					-> total results in db (not necessarily the returned count)
					i_feature_total_count			-> total results in db (not necessarily the returned count)
					i_feature_offset				-> offset of first feature in result (start) -> value is 0 based
					f_get_more_results				-> function to call to get more results (pagination)
													->	f_get_more_results(o_get_more_results_in)
													-> 		o_get_more_results_in = {
																i_feature_offset,
																i_feature_limit
															}
					
				}

				ex: 
				{
					a_table: [{s_table_urn: "urn__SEP__table__SEP__municipio__SEP__arvore_intervencao", a_geojson_feature: []}]
				}
			*/
			NSResultsInterface.f_reset_results_interface(o_in);
			
			
		}
		
		var o_in = {
			start: (offset==null)? 0 : offset,
			rows: i_constant_max_count,
			b_get_more_results: b_get_more_results
		}
		/*
			o_in:
			{
				start,	//zero based
				rows	//max number of returned rows
				b_get_more_results
			},
			f_callback_success -> function(o_result)
			f_callback_error -> function(o_result)
		*/
		this_.o_search_solr_struct.f_execute_solr_query(o_in, f_cb);
	},

	/**
	 * 
	 * @param {Array} a_suggestions 
	 * 
	 * @description
	 * a_suggestions: [ { value: "description text", data: {id, search_table_urn} }, ...]
	 */
	f_format_data_for_results_interface: function(a_suggestions)
	{

		let o_last_request_executed = this.o_search_solr_struct.f_get_o_last_request_executed_data();
		let b_use_filter = o_last_request_executed.b_use_filter;
		let s_table_urn = o_last_request_executed.o_searchable_collection?.urn; // for "no filter" search, object o_searchable_collection wont be defined 

		let a_geojson_feature = []
		a_suggestions.forEach((o_row_i) =>
			{
				let o_geo_json_feature = NSGeoJson.f_get_empty_geojson_feature();

				let s_search_table_urn = (b_use_filter)? s_table_urn : o_row_i.data.search_table_urn;

				
				o_geo_json_feature.properties["description"] = o_row_i.value;

				o_geo_json_feature.properties_extra={};
				o_geo_json_feature.properties_extra["id"] = o_row_i.data.id;
				o_geo_json_feature.properties_extra["search_table_urn"] = s_search_table_urn;
				//o_geo_json_feature.properties_extra["description_external_name"] = NSSearchbarPrivate.private_objs.settings.column_description_external_name;

				//let s_schema_internal_name = NSURN.f_get_urn_schema_name(s_search_table_urn);
				let s_table_internal_name = NSURN.f_get_urn_table_name(s_search_table_urn);
				//NSResultsInterfacePrivate expects the following id
				o_geo_json_feature["id"] = s_table_internal_name + "." + o_geo_json_feature.properties_extra.id;
				a_geojson_feature.push(o_geo_json_feature);

		});
		return a_geojson_feature;

	},
	
	
	
	objs: {
		
		/**
		@summary 
		SearchableCollection{
			urn,
			a_search_column_internal_name,
			result_id_column_internal_name,
			result_id_table_urn,
			placeholder,
			html_id
		}

		@param o_in:
		{
			urn,
			input_field_placeholder,
			a_search_column_internal_name,
			result_id_column_internal_name,
			result_id_table_urn
		}

		@description
		o_in: {
			urn, 													// -> collection urn
			input_field_placeholder,
			a_search_column_internal_name,							// -> columns used in search
			result_id_column_internal_name,							// -> id that is returned for found matches (optional)
			result_id_table_urn,									// -> if the returned id is for another table (optional)
			a_result_column_internal_name_to_add_to_description,	// -> columns added to result description
			result_description_column_separator,					// -> columns in result separator; optional, default values is ", "
			b_hide_search,											// -> if the returned id is for another table (optional)
		}

		*/
		SearchableCollection: function(o_in){
			this.urn = o_in.urn;			
			this.a_search_column_internal_name = o_in.a_search_column_internal_name;
			this.result_id_column_internal_name = o_in.result_id_column_internal_name;
			this.result_id_table_urn = o_in.result_id_table_urn;
			this.a_result_column_internal_name_to_add_to_description = o_in.a_result_column_internal_name_to_add_to_description;
			this.result_description_column_separator = o_in.result_description_column_separator;
			this.placeholder = o_in.input_field_placeholder;
			this.html_id = NSSearchbarPrivate.o_dd_search_struct.f_get_dd_button_html_id_by_col_urn(o_in.urn);
			this.b_hide_search = o_in.b_hide_search;
		}
		
	}
	
}